import { withText } from './Text';
import { Small } from './Text.styles';

const SmallText = withText(Small);

SmallText.displayName = 'SmallText';

export { SmallText };
